import React from 'react';
import { Collapse } from 'antd';
import { AuditLogEventResponse } from '../../api-client';
import { updatedDiff, addedDiff } from 'deep-object-diff';
import { IntlShape } from 'react-intl';

interface DetailsModalContentProps {
    log: AuditLogEventResponse;
    renderLogDetails: (logDetails: Record<string, any>) => React.ReactNode;
    formatLogDetails: (log: AuditLogEventResponse) => {
        formattedBefore: Record<string, any>;
        formattedAfter: Record<string, any>;
    };
    intl: IntlShape;
}

const DetailsModalContent: React.FC<DetailsModalContentProps> = ({
                                                                     log,
                                                                     renderLogDetails,
                                                                     formatLogDetails,
                                                                     intl,
                                                                 }) => {
    const { formattedBefore, formattedAfter } = formatLogDetails(log);

    // For CREATE events (empty before state), show all added fields
    // For UPDATE/DELETE events, show only changed fields
    const isCreateEvent = !formattedBefore || Object.keys(formattedBefore).length === 0;
    const diffResult = isCreateEvent
        ? addedDiff(formattedBefore, formattedAfter)
        : updatedDiff(formattedBefore, formattedAfter);

    const collapseItems = [
        {
            key: 'before',
            label: intl.formatMessage({ id: 'before' }),
            children: renderLogDetails(formattedBefore),
        },
        {
            key: 'after',
            label: intl.formatMessage({ id: 'after' }),
            children: renderLogDetails(formattedAfter),
        },
        {
            key: 'difference',
            label: intl.formatMessage({ id: 'difference' }),
            children: renderLogDetails(diffResult),
        },
    ];

    return (
        <Collapse
            items={collapseItems}
            bordered={false}
            defaultActiveKey={['before']}
        />
    );
};

export default DetailsModalContent;
